/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ISzfMapViewProps } from './szf-map';

export default (props: ISzfMapViewProps) => {
    const iFrameContainerClass = props.config.iFrameContainerClass;
    const iFrameSrc = props.config.iFrameSrc;
    const iFrameWidth = props.config.iFrameWidth;
    const iFrameHeight = props.config.iFrameHeight;
    const iFrameAllowFullScreen = props.config.iFrameAllowFullScreen;
    return (
        <div className={iFrameContainerClass || 'row'}>
            <iframe
                src={iFrameSrc}
                width={`${iFrameWidth}`}
                height={`${iFrameHeight}`}
                // style="border:0;"
                allowFullScreen={iFrameAllowFullScreen}
            >
            </iframe>
        </div>
    );
};
